var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 74,
    viewBox: "0 0 49 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9563 10.9106H0.029541V0H23.9563V10.9106ZM1.46982 9.4402H22.4573V1.47044H1.46982V9.4402Z",
    fill: "#209BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9725 20.3218H0.029541V9.41113H45.9725V20.3218ZM1.46982 18.8513H44.4734V10.8816H1.46982V18.8513Z",
    fill: "#209BB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6083 37.3784H0V26.4678H15.6083V37.3784ZM1.4697 35.908H14.1386V27.9382H1.4697V35.908Z",
    fill: "#209BB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4529 46.789H0V35.8784H29.4529V46.789ZM1.4697 45.3186H27.9831V37.3489H1.4697V45.3186Z",
    fill: "#209BB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5362 63.8467H0V52.936H37.5362V63.8467ZM1.4697 62.3762H36.0665V54.4065H1.4697V62.3762Z",
    fill: "#209BB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73.2568H0V62.3462H49V73.2568ZM1.4697 71.7864H47.5303V63.8166H1.4697V71.7864Z",
    fill: "#209BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup23);
export default __webpack_public_path__ + "static/media/Group23.3f97531bd09891f44ad29b8823c702cc.svg";
export { ForwardRef as ReactComponent };